<template>
  <modal-simple :closeBtn="false" :id="id" :footer="false" @okPressed="$emit('okPressed', true)"
                @cancelPressed="$emit('cancelPressed', true)"
                :title="title" style="font-size: 20px;float: none !important;">
<!--    <template v-slot:header>-->
<!--      <div class="background-standard shadow-standard mt-4" style="height: 60px; width: 100%">-->
<!--        <img src="@/assets/images/success-mark.png">-->
<!--      </div>-->
<!--    </template>-->
    <template v-slot:content>
        <br>
        <br>
      <h4 class="mb-4">{{ message }}</h4>
    </template>

  </modal-simple>
</template>

<script>
    import ModalSimple from './modal-simple';

    export default {
        name: 'modal-confirm',
        components: {ModalSimple},
        props:{
            id: String,
            message: String,
            title:{
                type: String,
                default: 'Confirmation de la suppression'
            }
        }
    };
</script>

<style scoped>

</style>
